import { Button } from '@wot/components';
import { CALENDAR } from '../../assets/images';
import { Link } from 'react-router-dom';

export default function TutorOpportunity() {
  return (
    <div className="flex container lg:justify-between mx-auto py-10 min-h-full">
      {/*For tutor div*/}
      <div className="flex flex-col lg:w-1/2 w-full">
        <div className="mb-0 lg:mb-20 flex flex-col gap-14 lg:items-start items-center">
          <div>
            <span className="md:text-2xl text-xl font-medium text-white">FOR TUTOR</span>
          </div>
          <div className="flex flex-col gap-5 lg:items-start items-center">
            <div className="lg:w-full w-4/5 lg:text-start text-center">
              <span className="md:text-4xl text-xl font-medium text-white">Find great opportunities</span>
            </div>
            <div className="w-full lg:w-4/5 lg:text-start text-center">
              <p className="md:text-lg text-base font-normal text-white">
                Earn money sharing your expert knowledge with students. Sign up to start tutoring online with
                WorldOTutors.
              </p>
            </div>
          </div>
        </div>
        <div>
          <div className="flex justify-center lg:hidden">
            <img src={CALENDAR} alt="Tutor Calendar" className="w-4/5" />
          </div>
          <div className="border-t-2 mb-10 lg:flex hidden"></div>
          <div className="flex lg:flex-row flex-col justify-around gap-5 lg:mt-0 mt-5">
            <div className="border rounded-3xl p-3">
              <span className="md:text-lg text-base font-medium text-white">Schedule your availability</span>
            </div>
            <div className="border rounded-3xl p-3">
              <span className="md:text-lg text-base font-medium text-white">Receive class bookings from students</span>
            </div>
            <div className="border rounded-3xl p-3">
              <span className="md:text-lg text-base font-medium text-white">Share the knowledge</span>
            </div>
          </div>
        </div>
        <Link to={process.env.REACT_APP_TUTOR_DOMAIN!} target="_blank" rel="noopener noreferrer">
          <div className="w-full lg:max-w-[150px] pt-5">
            <Button block text="Join as a tutor" size="lg" onClick={() => { }}  />
          </div>
        </Link>
      </div>
      <div className="lg:flex w-2/5 hidden">
        <img src={CALENDAR} alt="Tutor Calendar" className="object-cover" />
      </div>
    </div>
  );
}
